/**
 * CAPTION IT — Quiz Buy (pre-acquisto, con scelta variante)
 *
 * Per chi arriva da home (carrello vuoto). Al click su una variante:
 *  1. Aggiunge la variante al carrello (con quiz answers come properties)
 *  2. Setta cart attributes + note (riepilogo quiz)
 *  3. Redirect a /checkout
 */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.from((r || document).querySelectorAll(s)); }

  function init() {
    const root = $('[data-ci-quiz-buy]');
    if (!root) return;

    const form = $('[data-ci-quiz-buy-form]', root);
    const nameInput = $('[data-ci-qb-name]', root);
    const nameDisplays = $$('[data-ci-qb-name-display]', root);
    const variantBtns = $$('.ci-quiz-buy__variant', root);

    /* Live preview del nome */
    function updateNameDisplay(value) {
      const v = (value || '').trim() || 'lui/lei';
      nameDisplays.forEach(el => { el.textContent = v; });
    }
    nameInput?.addEventListener('input', e => updateNameDisplay(e.target.value));

    function getQuizAnswers() {
      const fd = new FormData(form);
      const answers = {};
      fd.forEach((value, key) => {
        const v = (value || '').toString().trim();
        if (v) answers[key] = v;
      });
      return answers;
    }

    function buildNote(answers) {
      const lines = ['QUIZ pre-acquisto:'];
      if (answers.festeggiato) lines.push('Festeggiato: ' + answers.festeggiato);
      if (answers.occasione)   lines.push('Occasione: ' + answers.occasione);
      const sopra = [answers.soprannome1, answers.soprannome2, answers.soprannome3].filter(Boolean);
      if (sopra.length) lines.push('Soprannomi: ' + sopra.join(', '));
      if (answers.tic) lines.push('Tic/frase: ' + answers.tic);
      const amici = [answers.amico1, answers.amico2].filter(Boolean);
      if (amici.length) lines.push('Amici stretti: ' + amici.join(', '));
      return lines.join('\n');
    }

    /* Variant button click → add to cart */
    variantBtns.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (btn.disabled) return;

        /* Validation: nome festeggiato richiesto */
        if (!nameInput?.value.trim()) {
          alert('Inserisci almeno il nome del festeggiato (Step 1)');
          nameInput?.focus();
          nameInput?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        const variantId = btn.dataset.variantId;
        const answers = getQuizAnswers();
        const originalText = btn.querySelector('.ci-quiz-buy__variant-cta').textContent;
        btn.disabled = true;
        btn.querySelector('.ci-quiz-buy__variant-cta').textContent = 'aggiungo…';

        try {
          /* WORKAROUND /cart/add.js 422: usa cart permalink invece dell'API JSON.
             Permalink: /cart/<variant_id>:1?attributes[...]=...
             - GET diretto, niente fetch
             - line item properties diventano cart-level attributes
               (visibili in admin Order, basta per l'utilizzo)
             - bypassa la validazione /cart/add.js che rifiuta come "sold out"
               anche con inventory_management=null (bug Shopify side) */
          const params = new URLSearchParams();
          if (answers.festeggiato)  params.append('attributes[Festeggiato]',  answers.festeggiato);
          if (answers.occasione)    params.append('attributes[Occasione]',    answers.occasione);
          if (answers.soprannome1)  params.append('attributes[Soprannome 1]', answers.soprannome1);
          if (answers.soprannome2)  params.append('attributes[Soprannome 2]', answers.soprannome2);
          if (answers.soprannome3)  params.append('attributes[Soprannome 3]', answers.soprannome3);
          if (answers.tic)          params.append('attributes[Tic/Frase]',    answers.tic);
          if (answers.amico1)       params.append('attributes[Amico 1]',      answers.amico1);
          if (answers.amico2)       params.append('attributes[Amico 2]',      answers.amico2);

          /* Salva note backup via /cart/update.js (best-effort, no fail) */
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ note: buildNote(answers) })
          }).catch(() => {});

          /* Redirect permalink — Shopify aggiunge variant + attributi e va al cart */
          const target = '/cart/' + variantId + ':1?' + params.toString() + '&return_to=/checkout';
          window.location.href = target;
        } catch (err) {
          alert('Errore: ' + (err.message || 'impossibile aggiungere al carrello'));
          btn.disabled = false;
          btn.querySelector('.ci-quiz-buy__variant-cta').textContent = originalText;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
